module.exports = __webpack_public_path__ + "img/SI-compare@2x.650b301.webp";